import { Quote, Star } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";

export default function Testimonials({ site, testimonials }) {
  const s = site?.testimonialsSection || {};
  return (
    <section className="py-24 lg:py-32 bg-[var(--c-primary)] relative overflow-hidden">
      <div className="absolute inset-0 bg-noise opacity-40" />
      <div className="absolute -bottom-32 -right-16 h-96 w-96 rounded-full bg-[var(--c-secondary)]/20 blur-3xl" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
        <Reveal className="text-center max-w-3xl mx-auto">
          <span className="divider-ornament font-body text-xs sm:text-sm font-semibold tracking-[0.25em] uppercase text-[var(--c-accent)]">{s.label}</span>
          <h2 className="font-heading font-bold text-[var(--c-bg)] mt-5 text-3xl sm:text-4xl lg:text-5xl">{s.title}</h2>
        </Reveal>

        <div className="grid sm:grid-cols-2 gap-6 mt-14">
          {(testimonials || []).map((t, i) => (
            <Reveal key={t.id || i} delay={(i % 2) * 0.1}>
              <figure
                data-testid={`testimonial-${i}`}
                className="h-full bg-[var(--c-bg)]/8 border border-white/15 backdrop-blur-sm rounded-2xl p-8 relative"
              >
                <Quote className="h-8 w-8 text-[var(--c-accent)] mb-4" />
                <blockquote className="font-heading text-lg sm:text-xl text-white/95 leading-relaxed">{t.quote}</blockquote>
                <figcaption className="flex items-center gap-4 mt-6 pt-5 border-t border-white/15">
                  <span className="grid place-items-center h-12 w-12 rounded-full bg-[var(--c-accent)] text-white font-heading text-lg overflow-hidden">
                    {t.photo ? <img src={t.photo} alt={t.name} className="h-full w-full object-cover" /> : (t.name || "শ")[0]}
                  </span>
                  <div>
                    <div className="font-body font-semibold text-white">{t.name}</div>
                    <div className="font-body text-sm text-white/60">{t.role}</div>
                  </div>
                  <div className="ml-auto flex gap-0.5">
                    {Array.from({ length: t.rating || 5 }).map((_, k) => (
                      <Star key={k} className="h-4 w-4 fill-[var(--c-accent)] text-[var(--c-accent)]" />
                    ))}
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
